import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import Loader from '../../Components/Loader';

import { useAuth } from '../../Context/Context';

import icon2 from "../../Images/Icon/63.png";

import ProfesoresCursos from '../../Helpers/ProfesoresCursos';
import useStorage from '../../Hooks/useStorage';


const View = () => {
    const { setEditar } = useAuth();

    const [profesores, setProfesores] = useState([]);
    const [flag, setFlag] = useState(false);
    const [id, setId] = useState("");

    // uso de hooks para agregar imagen a google storage
    const [consulta, setConsulta] = useState("");
    let [ response ] = useStorage(consulta);

    useEffect(() => {
        if (!response) {
            obtenerProfesores();
        } else {
            if (response.action === 'eliminar') {
                eliminarProfesor();
            }
        }
    },[response]);
    

    const obtenerProfesores = async () => {
        let res = await ProfesoresCursos.obtenerProfesores();
        if (res.success) {
            setProfesores(res.data);
            setFlag(true);
        } else {
            Swal.fire(
                'Error!',
                'No se lograron obtener los profesores, codigo: ' + res.code ,
                'error'
            )
        }
    }

    const eliminarProfesor = () => {
        ProfesoresCursos.eliminarProfesor(id);
    }

    const eliminarArchivo = profesor => {
        setId(profesor._id);

        setConsulta({consulta:"eliminar", url:"/profesores-cursos", urlFile:profesor.imagen});
    }

    const agregarProfesor = () => {
        let ventana = document.getElementById("ventana_editable_agregar");
        ventana.className = "ventana_editable col s3";
        let vista = document.getElementById("vistas_generales");
        vista.className = "col s9";
        let cerrar = document.getElementById("invisible_cerrar_agregar");
        cerrar.className = "invisible_cerrar_activado";
    }

    const editarProfesor = profesor => {
        let ventana = document.getElementById("ventana_editable_editar");
        ventana.className = "ventana_editable col s3";
        let vista = document.getElementById("vistas_generales");
        vista.className = "col s9";
        let cerrar = document.getElementById("invisible_cerrar");
        cerrar.className = "invisible_cerrar_activado";
        setEditar(profesor);
    }

    return (
        <div id='vistas_generales' className='col s12' style={{padding:"0"}}>
            <div className='container center'>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    Profesores para cursos
                </p>
                {!flag ? (
                    <div style={{display:"flex", justifyContent:"center", alignItems:"center", height:"60vh"}}>
                        <Loader />
                    </div>
                ) : (
                    <div>
                        <p style={{marginLeft:"25px"}} className='texto_solicitud'>
                            Nombre
                        </p>
                        <div>
                            {profesores.map(profesor => (
                                <div className='box_solicitud'>
                                    <div className='row'>
                                        <div className='col s10'>
                                            <div style={{marginLeft:"25px", display:"flex", gap:"15px", alignItems:"center"}}>
                                                <img src={profesor.imagen} alt={profesor.nombre} style={{width:"100px", borderRadius:"50%", marginRight:"50px"}} />
                                                <p className='texto_solicitud' style={{fontWeight:"bold"}}>
                                                    {profesor.nombre}
                                                </p>
                                                <p className='texto_solicitud'>
                                                    {profesor.certificado}
                                                </p>
                                            </div>   
                                        </div>
                                        <div className='col s2'>
                                            <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", paddingRight:"25px", height:"103px"}}>
                                                <img style={{cursor:"pointer"}} onClick={() => {eliminarArchivo(profesor)}} src={icon2} alt="" />
                                                <button onClick={() => {editarProfesor(profesor)}} className='caja_status' style={{backgroundColor:"#00496C", border:"none"}}>
                                                    <p>
                                                        EDITAR
                                                    </p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div style={{display:"flex", justifyContent:"center"}}>
                    <div className='boton_2_nv'>
                        <button onClick={agregarProfesor} >
                            <p>Agregar profesor</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default View;